// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--7-1!../../node_modules/postcss-loader/lib/index.js??ref--7-2!../../node_modules/less-loader/dist/cjs.js??ref--7-3!./index.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("51297618", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./static/my-theme/index.less
// module id = wxY7
// module chunks = 1